import { render, staticRenderFns } from "./ClinicListComponent.vue?vue&type=template&id=a285c8c6&scoped=true&"
import script from "./ClinicListComponent.vue?vue&type=script&lang=js&"
export * from "./ClinicListComponent.vue?vue&type=script&lang=js&"
import style0 from "./ClinicListComponent.vue?vue&type=style&index=0&id=a285c8c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a285c8c6",
  null
  
)

export default component.exports